<template>
  <el-dialog
    title="曝光"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    customClass="customWidth"
  >

        <el-form
                :inline="true"
                :model="searchForm"
                ref="searchForm"
                size="small"
                style="margin-bottom: -18px;"
        >

          <el-form-item>
            <el-date-picker
                    v-model="dateRange"
                    :picker-options="pickerOptions"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"    width="150">

            </el-date-picker>

          </el-form-item>

          <el-form-item>
            <el-button
                    type="primary"
                    @click="handleSearchFormSubmit"
            >
              <d2-icon name="search" /> 查询
            </el-button>
            <el-button @click="handleSearchFormReset">
              <d2-icon name="refresh" /> 重置
            </el-button>
          </el-form-item>
        </el-form>

      <el-table
              :data="tableData"
              v-loading="loading"
              size="small"
              stripe
              highlight-current-row
              style="width: 100%;"
              @selection-change="handleSelectionChange"
              @sort-change="handleSortChange"
      >

        <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
        </el-table-column>

        <el-table-column
                label="商户"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.agentname}}
          </template>
        </el-table-column>
        <el-table-column
                label="曝光时间"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{scope.row.start_time}}
          </template>
        </el-table-column>

      </el-table>
    <div style="text-align: center;margin-top: 30px;">
        <el-pagination
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                :page-sizes="[1,10,50,100, 200, 300, 400]"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin: -10px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
        >
        </el-pagination>

    </div>
  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'agentEditForm',
  props: {
    agent: Object,
    value: Boolean
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      searchForm: {
        mer_order_id: ''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      dateRange: [],
      pickerOptions: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.searchForm.resetFields()
      this.getTableData()
    },
    dateConversion (value) {
      if (value != null && value != '') {
        var d = new Date(value)
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.info('===========date=========' + date)
        return date
      } else {
        return ''
      }
    },
    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        advert_id: this.agent.id,
        type: '0',
        start_time: this.dateConversion(this.dateRange[0]),
        end_time: this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      agentService.getAdvertExposurePagedList(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    close () {
      this.$refs['searchForm'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
<style>
  .customWidth{
    width:60%;
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
